<script setup>
	import CloseIcon from "./CloseIcon.vue";
	import { VBtn } from "vuetify/components";

	const props = defineProps({
		class: Array,
		disabled: Boolean
	});
	const emit = defineEmits([ "click" ]);

	function raiseClickEmit() {
		emit("click");
	}
</script>

<template>
	<VBtn title="Close"
		:class="props.class.concat(['mx-2', 'close-action'])"
		:disabled="props.disabled"
		@click="raiseClickEmit">
		<CloseIcon/>
	</VBtn>
</template>
